import IconMore from '@bimser/icons/16/more';
import { TextBox, TextBoxRef } from 'devextreme-react/text-box';
import React from 'react';

export const CollectionBox: React.FC<any> = props => {
	const textboxRef = React.useRef<TextBoxRef>();

	const onValueChanged = (value: string) => {
		props.data.setValue(value);
		textboxRef.current.instance().option('value', value);
	};

	return (
		<TextBox
			defaultValue={props.value}
			ref={textboxRef}
			onValueChange={onValueChanged}
			buttons={[
				{
					name: 'collectionSelector',
					location: 'after',
					options: {
						icon: IconMore.info.getElement(),
						stylingMode: 'text',
						onClick: () => props.data.column.editorOptions?.onClick(onValueChanged)
					}
				}
			]}
		/>
	);
};
